import {loadGoogleTagManager as loadGtm} from "@pg-mono/google-tag-manager";

import {gtmId, gtmLoadUrl, gtmScriptId, gtmScriptParams, gtmUrl} from "../../app/read_rp_environment_variables";
import {getViewTypeName, ViewType} from "../../view_type/ViewType";
import {hitGoogleTagManager, IGtmData} from "./hit_google_tag_manager";

declare global {
    interface Window {
        dataLayer: object[];
        pgGtmLib: {
            gtmHitLib: (gtmData: IGtmData) => void;
        };
    }
}

/**
 * Init
 */
export const initGoogleTagManager = (): void => {
    const win = window as Window;

    loadGtm({
        containerId: gtmId,
        gtmUrl: gtmUrl,
        gtmLoadUrl: gtmLoadUrl,
        scriptId: gtmScriptId,
        scriptParams: gtmScriptParams
    });

    // this exception is provided only for desktop-homepage (for now) - requires favourites unification
    win.pgGtmLib = win.pgGtmLib || {};
    win.pgGtmLib.gtmHitLib = hitGoogleTagManager; // make it available for desktop integrations, e.g. homepage
};

/**
 * Config
 */
interface IConfigGTM {
    viewType: ViewType | null;
    regionName: string | null;
    vendorName: string | null;
    userId: string | null;
    userGaId: string | null;
    blogCategory: string[] | null;
    businessStatus: string | null;
    investorPotential: string | null;
    hasPageProjection2d?: boolean | null;
}
export const configGoogleTagManager = (config: IConfigGTM): void => {
    const win = window as Window;

    // initialize only in browser
    if (process.env.EXEC_ENV !== "browser") {
        return;
    }

    interface IGtmGroup {
        pageType: string;
        contentRegion: string;
        contentDeveloperName: string;
        userID_CRM: string | null;
        userID_GA: string;
        userLoggedIn: "tak" | "nie";
        blogCategory: string[] | string;
        businessStatus: string;
        investorPotential: string;
        projection2d: string;
    }

    // on page load run script to group future content sent do GTM
    (function (w: Window, dataLayer: "dataLayer") {
        w[dataLayer] = w[dataLayer] || [];
        const gtmData: IGtmGroup = {
            pageType: config.viewType != null ? getViewTypeName(config.viewType) : "na",
            contentRegion: config.regionName ?? "na",
            contentDeveloperName: config.vendorName ?? "na",
            userID_CRM: config.userId ?? null,
            userID_GA: config.userGaId ?? "na",
            userLoggedIn: config.userId != null ? "tak" : "nie",
            blogCategory: config.blogCategory ?? "na",
            businessStatus: config.businessStatus ?? "na",
            investorPotential: config.investorPotential ?? "na",
            projection2d: config.hasPageProjection2d ? "tak" : "nie"
        };
        w[dataLayer].push(gtmData);
    })(win, "dataLayer");
};
import {loadGoogleTagManager as loadGtm} from "@pg-mono/google-tag-manager";

import {gtmId, gtmLoadUrl, gtmScriptId, gtmScriptParams, gtmUrl} from "../../app/read_rp_environment_variables";
import {getViewTypeName, ViewType} from "../../view_type/ViewType";
import {hitGoogleTagManager, IGtmData} from "./hit_google_tag_manager";

declare global {
    interface Window {
        dataLayer: object[];
        pgGtmLib: {
            gtmHitLib: (gtmData: IGtmData) => void;
        };
    }
}

/**
 * Init
 */
export const initGoogleTagManager = (): void => {
    const win = window as Window;

    loadGtm({
        containerId: gtmId,
        gtmUrl: gtmUrl,
        gtmLoadUrl: gtmLoadUrl,
        scriptId: gtmScriptId,
        scriptParams: gtmScriptParams
    });

    // this exception is provided only for desktop-homepage (for now) - requires favourites unification
    win.pgGtmLib = win.pgGtmLib || {};
    win.pgGtmLib.gtmHitLib = hitGoogleTagManager; // make it available for desktop integrations, e.g. homepage
};

/**
 * Config
 */
interface IConfigGTM {
    viewType: ViewType | null;
    regionName: string | null;
    vendorName: string | null;
    userId: string | null;
    userGaId: string | null;
    blogCategory: string[] | null;
    businessStatus: string | null;
    investorPotential: string | null;
    hasPageProjection2d?: boolean | null;
}
export const configGoogleTagManager = (config: IConfigGTM): void => {
    const win = window as Window;

    // initialize only in browser
    if (process.env.EXEC_ENV !== "browser") {
        return;
    }

    interface IGtmGroup {
        pageType: string;
        contentRegion: string;
        contentDeveloperName: string;
        userID_CRM: string | null;
        userID_GA: string;
        userLoggedIn: "tak" | "nie";
        blogCategory: string[] | string;
        businessStatus: string;
        investorPotential: string;
        projection2d: string;
    }

    // on page load run script to group future content sent do GTM
    (function (w: Window, dataLayer: "dataLayer") {
        w[dataLayer] = w[dataLayer] || [];
        const gtmData: IGtmGroup = {
            pageType: config.viewType != null ? getViewTypeName(config.viewType) : "na",
            contentRegion: config.regionName ?? "na",
            contentDeveloperName: config.vendorName ?? "na",
            userID_CRM: config.userId ?? null,
            userID_GA: config.userGaId ?? "na",
            userLoggedIn: config.userId != null ? "tak" : "nie",
            blogCategory: config.blogCategory ?? "na",
            businessStatus: config.businessStatus ?? "na",
            investorPotential: config.investorPotential ?? "na",
            projection2d: config.hasPageProjection2d ? "tak" : "nie"
        };
        w[dataLayer].push(gtmData);
    })(win, "dataLayer");
};
